import { render, staticRenderFns } from "./order-item-added-notification.vue?vue&type=template&id=af969832&scoped=true&lang=pug&"
import script from "./order-item-added-notification.vue?vue&type=script&lang=js&"
export * from "./order-item-added-notification.vue?vue&type=script&lang=js&"
import style0 from "./order-item-added-notification.vue?vue&type=style&index=0&id=af969832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af969832",
  null
  
)

export default component.exports